
import { defineComponent } from "vue";
import { useStore } from "@/store/store";
import Repositories from "@/components/Repositories.vue";
import useRepos from "@/hooks/useRepos";
import { getTopStarsRepos } from "@/utils/helper";

export default defineComponent({
  name: "Home",
  components: {
    Repositories
  },
  async setup() {
    const store: Store = useStore();
    const { state } = store;
    const { userRepos } = await useRepos(state.preDefinedUser);
    const { value } = userRepos;
    const repos: Repo[] | undefined = getTopStarsRepos(value, 3);
    return {
      store,
      repos
    };
  }
});
